import { useState } from 'react';

const useNumericValue = (enteredvalue) => {

  const [value, setValue] = useState(enteredvalue);

  const setFieldsValue = (enteredvalue) => {
    // only allows 0-9 inputs
    const currentValue = enteredvalue.replace(/[^\d]/g, '');
    setValue(currentValue);
    return currentValue;
  };

  return {
    returnValue: value,
    setFieldsValue: setFieldsValue,
  };

};

export default useNumericValue;